import { render, staticRenderFns } from "./maximize.vue?vue&type=template&id=433aaefc&"
import script from "./maximize.vue?vue&type=script&lang=js&"
export * from "./maximize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('433aaefc')) {
      api.createRecord('433aaefc', component.options)
    } else {
      api.reload('433aaefc', component.options)
    }
    module.hot.accept("./maximize.vue?vue&type=template&id=433aaefc&", function () {
      api.rerender('433aaefc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/maximize.vue"
export default component.exports